/* eslint-disable */
// Meta (Facebook) initialization script provided by Jane marketing team
// Note that this approach was chosen to workaround content security policy issues that prevented
// the use of the <script> tag directly in the HTML file, which is the standard
// way to include Meta/Facebook tracking
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '478029256059576');
fbq('track', 'PageView');